import { render, staticRenderFns } from "./index-around.vue?vue&type=template&id=228560af&scoped=true"
import script from "./index-around.vue?vue&type=script&lang=js"
export * from "./index-around.vue?vue&type=script&lang=js"
import style0 from "./index-around.vue?vue&type=style&index=0&id=228560af&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228560af",
  null
  
)

export default component.exports